export const getNavigationListEndpoint = (deviceUuid: string): string => `/api/Navigation/${deviceUuid}/list`;

export const getNavigationFeaturesListEndpoint = (deviceUuid: string, featureRef: string): string => `/api/Navigation/${deviceUuid}/features/${featureRef}`;

